"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const PopoverModalForm_1 = require("../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const src_2 = require("@rover/ts-bootstrap/dist/src");
class TimePickerContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tempSeconds: null,
        };
        this.getPopoverFormInputProps = this.getPopoverFormInputProps.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.updateTempTime = this.updateTempTime.bind(this);
        this.getAddChangeButton = this.getAddChangeButton.bind(this);
    }
    getPopoverFormInputProps() {
        const { device, getDisplayTime } = this.props;
        return {
            id: `scheduledCampaign_time_picker`,
            label: 'Time',
            media: device,
            text: getDisplayTime(),
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            isEditingText: false,
        };
    }
    handleAdd() {
        const { dateTime, updateScheduledCampaignTrigger } = this.props;
        const { tempSeconds } = this.state;
        updateScheduledCampaignTrigger({
            dateTime: Object.assign(Object.assign({}, dateTime), { time: tempSeconds }),
        });
    }
    handleClose() {
        this.setState({
            tempSeconds: undefined,
        });
    }
    updateTempTime(seconds) {
        this.setState({
            tempSeconds: seconds,
        });
    }
    getAddChangeButton(text) {
        return (React.createElement("div", { key: "time-picker-add-change" },
            React.createElement(src_2.Button, { text: text, type: "regular", style: {
                    innerStyle: {
                        fontSize: 17,
                    },
                    outerStyle: {
                        height: null,
                        lineHeight: '24px',
                    },
                }, mouseDownColors: {
                    active: src_2.turquoise,
                    inactive: src_2.aquamarine,
                } })));
    }
    render() {
        const { dateTime, device } = this.props;
        const { tempSeconds } = this.state;
        const getPopoverNavbarProps = (handleClosePopoverModal) => ({
            buttonRight: 'Done',
            buttonRightCallback: () => {
                this.handleAdd();
                handleClosePopoverModal();
            },
            buttonLeftCallback: () => {
                this.handleClose();
                handleClosePopoverModal();
            },
        });
        const getPopoverModalProps = (handleClosePopoverModal) => {
            return {
                placement: 'left',
                navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                        containerStyle: {
                            borderRadius: '3px 3px 0px 0px',
                        },
                    } }, getPopoverNavbarProps(handleClosePopoverModal)),
            };
        };
        return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: this.getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: `scheduledCampaign_time_picker`, popoverModalProps: getPopoverModalProps, popoverNavbarProps: getPopoverNavbarProps, handleShowPopoverForm: this.handleClose, addButton: device === 'Desktop' ? (this.getAddChangeButton('Add')) : (React.createElement(src_2.PlusIcon, { key: "time-picker-add-change", fill: src_2.titanium })), editButton: device === 'Desktop' ? (this.getAddChangeButton('Change')) : (React.createElement(src_2.ChangeIcon, { key: "time-picker-add-change", fill: src_2.titanium })) },
            React.createElement("div", { key: "time-picker-component", style: {
                    padding: device === 'Mobile' ? 24 : 16,
                } },
                React.createElement(src_1.TimePicker, { handleSecondsChange: this.updateTempTime, seconds: tempSeconds || dateTime.time || 0, containerStyle: {
                        width: device !== 'Mobile' ? 352 : 'none',
                    } }))));
    }
}
const mapStateToProps = (state) => ({
    dateTime: reducers_1.getEditableCampaignScheduledCampaignTrigger(state).dateTime,
    getDisplayTime: () => reducers_1.getEditableCampaignDisplayTime(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateScheduledCampaignTrigger: (t) => {
            dispatch(actions_1.updateScheduledCampaignTrigger(t));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TimePickerContainer);
